import { baseUrl, headers, jwtHeaders, logoutUtil } from '../common/data';

export const signup = async (data) => {
  const response = await fetch(`${baseUrl}/admin/signup`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const login = async (data) => {
  const response = await fetch(`${baseUrl}/api/superadmin/login`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });
  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const getSuperAdmin = async (id) => {
  const response = await fetch(`${baseUrl}/api/superadmin/findadmin/${id}`, {
    method: 'GET',
    headers,
    redirect: 'follow',
  });

  const resData = await response.json();
  return resData;
};

export const forgotpassowrd = async (data) => {
  const response = await fetch(`${baseUrl}/api/superadmin/forgotpassword`, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};
